(ns hai.contacts.avatar
  "The contact's glyph, shared by the card and the editor: the group icon for
   an organisation, initials for a named person, the person icon otherwise."
  (:require
   [clojure.string :as str]
   [hai.contacts.helpers :as helpers]
   [hai.ui.tokens :as t]
   [lambdaisland.ornament :as o]))

(o/defstyled circle :div
  :flex :items-center :justify-center :flex-shrink-0
  {:width "36px"
   :height "36px"
   :border-radius "50%"
   :background-color t/--colour-chalk
   :color t/--text-secondary-50
   :font-size "12px"
   :font-weight "700"
   :letter-spacing "0.03em"
   :user-select "none"}
  [:svg {:width "18px" :height "18px" :flex-shrink "0"}])

(defn initials [full-name]
  (->> (str/split (or full-name "") #"\s+")
       (keep first)
       (take 2)
       (apply str)
       str/upper-case))

(defn avatar
  [{:contact/keys [full-name] :as contact}]
  (let [org? (helpers/org? contact)]
    [circle {:title (if org? "Organisation" "Individual")}
     (cond
       org?            [helpers/org-icon]
       (seq full-name) (initials full-name)
       :else           [helpers/icon])]))
